<template>
  <section>
    <h1 class="text-2xl font-bold tracking-tight text-slate-900 mb-4">
      User Account List
    </h1>
    <div class="container mx-auto p-2 sm:p-4 lg:p-6 bg-white rounded-lg">
      <div class="px-0 sm:px-0 lg:px-0">
        <div class="sm:flex flex-col sm:items-left px-4">
          <nav class="mb-4" aria-label="breadcrumb">
            <ol
              class="flex leading-none text-gray-dark divide-x divide-indigo-400"
            >
              <li class="pr-4">
                <router-link
                  :to="{ name: 'AdminTrainers' }"
                  exact-active-class="text-gray-dark"
                >
                  Trainer Profiles
                </router-link>
              </li>
              <li class="px-4 text-gray-light">
                <router-link :to="{ name: 'AdminUsers' }">
                  Attendee Profiles
                </router-link>
              </li>
            </ol>
          </nav>
          <div class="relative text-gray-700 w-full">
            <input
              class="w-full h-10 pl-8 pr-3 text-base placeholder-gray-600 border-1 rounded-lg focus:outline-none"
              type="text"
              placeholder="Search By Name or Email"
              v-model.lazy="search"
            />
            <div
              class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="mt-4 flow-root">
          <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
            >
              <div class="relative">
                <!-- Selected row actions, only show when rows are selected. -->
                <!-- <div class="absolute top-0 left-14 flex h-12 items-center space-x-3 bg-white sm:left-12"> -->
                <!--   <button type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">Bulk edit</button> -->
                <!--   <button type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">Delete all</button> -->
                <!-- </div> -->

                <table class="min-w-full table-fixed divide-y divide-gray-300">
                  <thead>
                    <tr v-if="fields && fields.length">
                      <!-- <th scope="col" class="relative px-7 sm:w-12 sm:px-6">
                        <input
                          type="checkbox"
                          class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </th> -->
                      <!-- <th
                        scope="col"
                        class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        Name
                      </th> -->
                      <th
                        scope="col"
                        class="pr-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        :class="d.sort ? 'cursor-pointer' : ''"
                        v-for="(d,index) in fields"
                        :key="index"
                        @click="d.sort ? activateSortHandler(d) : ''"
                      >
                        {{ d.name }}
                        <i v-if="d.sort && d.sort === 'default'" class="fa fa-sort" aria-hidden="true"></i>
                        <i v-else-if="d.sort && d.sort === 'desc'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        <i v-else-if="d.sort && d.sort === 'asc'" class="fa fa-sort-asc" aria-hidden="true"></i>
                      </th>
                      <!-- <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                        <span class="sr-only">Edit</span>
                      </th> -->
                    </tr>
                  </thead>
                  <tbody
                    class="divide-y divide-gray-200 bg-white"
                    v-if="items && items.length"
                  >
                    <!-- Selected: "bg-gray-50" -->
                    <tr v-for="d in items" :key="d.id">
                      <!-- <td class="relative px-7 sm:w-12 sm:px-6">
                        Selected row marker, only show when row is selected.
                        <div class="absolute inset-y-0 left-0 w-0.5 bg-indigo-600"></div>

                        <input
                          type="checkbox"
                          class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        />
                      </td> -->
                      <!-- Selected: "text-indigo-600", Not Selected: "text-gray-900" -->
                      <td
                        class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-blue-700 hover:underline capitalize"
                      >
                        <router-link
                          :to="{
                            name: 'AdminTrainersProfileAbout',
                            params: { id: d.id },
                          }"
                          target="_blank"
                        >
                          {{ d.f_name }}
                        </router-link>
                      </td>
                      <td
                        class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900 capitalize"
                      >
                        {{ d.l_name }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.account_created_time }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ handleLastLogin(d.last_login) }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.email }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ intToFloat(d.amount_earned, 2) || "NA" }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.total_booked_sessions || "NA" }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.total_booked_courses || "NA" }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                      >
                        {{ d.is_active_boolean ? 'In-Active' : 'Active' }}&nbsp;
                        <label class="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" v-model="d.is_active_boolean" class="sr-only peer" @click="toggleUserStatusHandler(d)">
                          <div class="w-11 h-6 bg-gray-400 rounded-full peer 
                          dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
                          after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
                            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                            after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                        </label>
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 flex items-center text-sm text-gray-dark"
                      >
                        {{ d.platform_fee_exception_boolean ? 'No Fee' : 'Active' }}&nbsp;
                        <label class="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" v-model="d.platform_fee_exception_boolean" class="sr-only peer" @click="toggleTrainerFeesHandler(d)">
                          <div class="w-11 h-6 bg-gray-400 rounded-full peer 
                          dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
                          after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
                            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                            after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                        </label>
                      </td>
                      <!-- <td
                        class="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3"
                      >
                        <a
                          href="#"
                          class="text-indigo-600 hover:text-indigo-900"
                          >Edit<span class="sr-only">, Lindsay Walton</span></a
                        >
                      </td> -->
                    </tr>

                    <!-- More people... -->
                  </tbody>
                </table>
                <PaginationComponent
                  v-if="items.length"
                  :currentPage="current_page"
                  :handlePageChange="handlePageChange"
                  :totalPages="last_page"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      :title="'Confirmation'" v-model="toggleConfirm"
      :handleClose="closeModalHandler"
    >
      <div class="rediret-warn flex flex-col items-center justify-end">
        <p>
          {{ modalQuery['text'] }}
        </p>
        <div class="flex items-center justify-end w-full pt-6">
          <button 
            @click="confirmModalHandler"
            class="h-8 px-2 float-right text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"> 
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import { PaginationComponent,Modal } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import Vue from 'vue';

export default {
  name: "AdminTrainers",
  components: {
    PaginationComponent,
    Modal
  },
  data() {
    return {
      fields: [
        { name: "First Name", sort: 'default', keyName: 'f_name' },
        { name: "Last Name", sort: 'default', keyName: 'l_name' },
        { name: "Account Created Date", sort: 'default', keyName: 'account_created_time' },
        { name: "Last Active", sort: 'default', keyName: 'last_login' },
        { name: "Email", sort: 'default', keyName: 'email' },
        { name: "Amount Earned (USD)", sort: 'default', keyName: 'amount_earned' },
        { name: "Booked Classes", sort: 'default', keyName: 'total_booked_sessions' },
        { name: "Booked Courses", sort: 'default', keyName: 'total_booked_courses' },
        { name: "Status", sort: false, keyName: 'is_active' },
        { name: "Platform Fee", sort: false, keyName: 'platform_fee_exception' }
      ],
      items: [],
      items_init: [],
      current_page: 1,
      last_page: 1,
      search: null,
      toggleConfirm: false,
      selectedUserObj: null,
      modalQuery: {
        text: null,
        operation: null
      },
      sortParams: null
    };
  },
  watch: {
    search() {
      this.handleGetAdminUsers();
    },
  },
  computed: {
    ...mapGetters(["adminUsers"]),
  },
  methods: {
    ...mapActions(["getAdminUsers"]),
    async handlePageChange(page) {
      await this.handleGetAdminUsers({page: page, ...this.sortParams})
    },

    async handleGetAdminUsers(payloadQuery) {
      const query = {
        search: this.search,
        user_type: this.TRAINER,
        ...payloadQuery
      };
      await this.getAdminUsers({ query });
      this.items_init = this.adminUsers.data;
      this.items = this.items_init.map((obj) => ({
        ...obj,
        platform_fee_exception_boolean: Boolean(obj.platform_fee_exception),
        init_fee_state: Boolean(obj.platform_fee_exception),
        init_is_active_state: !Boolean(obj.is_active),
        is_active_boolean: !Boolean(obj.is_active)
      }));
      this.last_page = this.adminUsers.last_page
      this.current_page = this.adminUsers.current_page
    },
    toggleModalHandler () {
      this.toggleConfirm = !this.toggleConfirm
    },
    toggleTrainerFeesHandler (dataObj) {
      this.selectedUserObj = dataObj
      this.modalQuery['text'] = 'Are you sure you want to toggle the platform fees for the trainer?'
      this.modalQuery['operation'] = 'fees'
      this.toggleModalHandler()
    },
    toggleUserStatusHandler (dataObj) {
      this.selectedUserObj = dataObj
      const flagText = dataObj.is_active ? 'In-Active' : 'Active'
      this.modalQuery['text'] = `Are you sure you want to mark user ${flagText}  on the platform?`
      this.modalQuery['operation'] = 'activeStatus'
      this.toggleModalHandler()
    },
    closeModalHandler () {
      this.toggleModalHandler()
      this.revertToggleHandler()
    },
    confirmModalHandler () {
      if(this.modalQuery['operation'] && this.modalQuery['operation'] === 'fees') {
        this.platformFeesHandler()
      } else {
        this.userStatusChangeHandler()
      }
    },
    revertToggleHandler () {
      let newObj = {}
      if (this.modalQuery['operation'] && this.modalQuery['operation'] === 'fees') {
        newObj = {
          ...this.selectedUserObj,
          platform_fee_exception_boolean: this.selectedUserObj.init_fee_state
        }
      } else {
        newObj = {
          ...this.selectedUserObj,
          is_active_boolean: this.selectedUserObj.init_is_active_state
        }
      }
      const index = this.items.indexOf(this.selectedUserObj)
      Vue.set(this.items, index, newObj)
    },
    async platformFeesHandler () {
      this.toggleModalHandler()
      await this.$store.dispatch('updateAdminTrainerPlatformFees', this.selectedUserObj.id).then((res) => {
        if (res && res.data) {
          const newObj = {
            ...this.selectedUserObj,
            platform_fee_exception_boolean: Boolean(res.data.platform_fee_exception),
            init_fee_state: Boolean(res.data.platform_fee_exception)
           }
          const index = this.items.indexOf(this.selectedUserObj)
          Vue.set(this.items, index, newObj)
          this.$store.commit("setIsSuccess", res && res.message);
        }
      }).catch((err) => {
        this.revertToggleHandler()
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
    },
    async userStatusChangeHandler () {
      this.toggleModalHandler()
      await this.$store.dispatch('updateUserStatus', this.selectedUserObj).then((res) => {
        if (res && res.data) {
          const newObj = {
            ...this.selectedUserObj,
            init_is_active_state: !Boolean(res.data.is_active),
            is_active_boolean: !Boolean(res.data.is_active),
            is_active: res.data.is_active
           }
          const index = this.items.indexOf(this.selectedUserObj)
          Vue.set(this.items, index, newObj)
          this.$store.commit("setIsSuccess", res && res.message);
        }
      }).catch((err) => {
        this.revertToggleHandler()
        this.$store.commit('setError', {title: "Alert", text: err.message})
      })
    },
    activateSortHandler (obj) {
      this.sortParams = {
        sort: obj.keyName
      }
      if(obj && obj.sort && obj.sort === 'default') {
        this.sortParams.sort_order = 'desc'
        obj.sort = 'desc'
      } else if (obj && obj.sort && obj.sort === 'desc') {
        this.sortParams.sort_order = 'asc'
        obj.sort = 'asc'
      } else if (obj && obj.sort && obj.sort === 'asc') {
        this.sortParams.sort_order = 'desc'
        obj.sort = 'desc'
      }
      this.fields && this.fields.map((itm) => {
        itm.keyName === obj.keyName ? '' : itm.sort ? itm.sort = 'default' : ''
        return itm
      })
      this.handleGetAdminUsers(this.sortParams)
    }
  },
  created() {
    this.handleGetAdminUsers({page: this.current_page});
  },
};
</script>